export default (theme) => ({
	closeModal: {
		position: "absolute",
		top: 4,
		right: 4,
		color: "grey.500",
	},
	modalHead: {
		fontSize: 26,
		lineHeight: "32px",
		fontWeight: 700,
		marginBottom: 12,
	},
	buttonSocial: {
		"backgroundColor": "#ffffff",
		"border": "1px solid #babfc3",
		"&:hover": { backgroundColor: "rgba(9, 30, 66, 0.05)" },
		"height": 52,
	},
	btn: {
		height: 52,
	},
});
